import styled from '@emotion/styled';
import { css as customCss } from '@emotion/react';

import { IButtonFilter } from '../../../Home/components/Filters/types';

export const ButtonFilter = styled.button<IButtonFilter>`
  margin: 0;
  padding: 10px 20px;
  border: none;
  outline: none;
  cursor: pointer;
  width: ${({ width }) => width};

  ${({ variant }) => {
    if (variant === 'left') {
      return customCss`
        border-radius: 16px 0px 0px 16px;
        `;
    }

    return customCss`
        border-radius: 0 16px 16px 0px;
        `;
  }}
  ${({ selected }) => {
    if (selected) {
      return customCss`
        background: #2e7d32;
        color: #fff;
        font-weight: 600;
        `;
    }

    return customCss`
        background:#d3d3d3;
        color: #585858;
        `;
  }}
`;
